import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=96e0a956&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"
import style0 from "./Contato.vue?vue&type=style&index=0&id=96e0a956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e0a956",
  null
  
)

export default component.exports